import Alert from '@mui/material/Alert'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import type { DeclaredCredit } from '@/types/Activity'

interface Props {
  declaredCredit: DeclaredCredit[]
  hasUnsatisfiedCredit: boolean
}

const ApplicantDeclarations = ({ declaredCredit, hasUnsatisfiedCredit }: Props) => {
  const hasNoDeclaredCredit = declaredCredit.length === 0

  return (
    <>
      <Typography
        variant="h6"
        component="h3"
        fontWeight={700}
        fontSize="14px"
        sx={{
          mt: 5,
          mb: 1,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span>Applicant declarations</span>
        {!hasNoDeclaredCredit && (
          <span style={{ color: '#4F4F4F' }}>({declaredCredit.length} declared)</span>
        )}
      </Typography>
      <Typography fontWeight={400} fontSize="12px" sx={{ mb: 1 }}>
        Here's what the applicant has declared when asked about their credit history
      </Typography>

      {hasNoDeclaredCredit ? (
        <Alert
          severity={hasUnsatisfiedCredit ? 'warning' : 'info'}
          sx={{ borderRadius: 2, my: 2 }}
        >
          Applicant did not declare any adverse credit
        </Alert>
      ) : (
        <TableContainer>
          <Table aria-label="Applicant Declarations Table">
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell align="left">Amount</TableCell>
                <TableCell align="left">Associated address</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {declaredCredit.map((row, i) => (
                <TableRow
                  key={`${row.type}-${row.amount}-${
                    row.address?.trim() || `no-address-${i}`
                  }`}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.type}
                  </TableCell>
                  <TableCell align="left">£{row.amount.toFixed(2)}</TableCell>
                  <TableCell align="left">{row.address?.trim() || 'Not found'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  )
}
export default ApplicantDeclarations
